import React from 'react';

export interface PuBenefitDateLineProps {
  resetsInDays: number;
}

export function PuBenefitDateLine({ resetsInDays }: PuBenefitDateLineProps) {
  const trackDays = Math.max(60, resetsInDays);
  const todayPct = 8;
  const resetPct = Math.min(96, todayPct + (resetsInDays / trackDays) * 80);

  return (
    <div className="relative mt-1">
      <div
        className="h-[3px] rounded-full opacity-75"
        style={{
          background:
            'linear-gradient(90deg, var(--success) 0%, var(--gold) 70%, var(--terracotta) 100%)',
        }}
      />
      <div
        className="absolute top-[-4px]"
        style={{ left: `${todayPct}%`, transform: 'translateX(-50%)' }}
      >
        <div
          className="h-[11px] w-[11px] rounded-full border-2 border-[var(--cream-1)] shadow-[var(--sh-1)]"
          style={{ background: 'var(--success)' }}
        />
      </div>
      <div
        className="absolute top-[-4px]"
        style={{ right: `${100 - resetPct}%`, transform: 'translateX(50%)' }}
      >
        <div
          className="h-[11px] w-[11px] rounded-full border-2 border-[var(--terracotta)] shadow-[var(--sh-1)]"
          style={{ background: 'var(--cream-1)' }}
        />
      </div>
      <div className="mt-2.5 flex justify-between text-[11px] text-[var(--ink-3)]">
        <span className="font-semibold text-[var(--success)]">Today</span>
        <span className="font-semibold text-[var(--terracotta)]">Benefits reset</span>
      </div>
    </div>
  );
}
